import { useEffect, useRef, useState } from 'react'

import { TextField } from '@material-ui/core'
import { debounce } from 'lodash'

const SearchTextField = ({
  defaultValue,
  onChange,
}: {
  defaultValue?: string
  onChange: (val: string | undefined) => void
}) => {
  const [value, setValue] = useState(defaultValue || '')
  const hasUserStartedTyping = useRef(false)

  useEffect(() => {
    setValue(defaultValue || '')
  }, [defaultValue])

  const handler = useRef<typeof onChange>(onChange)
  handler.current = onChange

  const debounced = useRef(
    debounce((val?: string) => {
      handler.current(val || undefined)
      hasUserStartedTyping.current = false
    }, 300),
  )

  useEffect(() => {
    const v = value === '' ? undefined : value
    if (!hasUserStartedTyping.current) {
      return
    }
    debounced.current(v)
  }, [value, debounced])
  return (
    <TextField
      fullWidth
      value={value}
      id="school-name-search"
      label="Search school name"
      variant="outlined"
      size="small"
      onChange={(e) => {
        const newValue = e.target.value
        hasUserStartedTyping.current = true
        setValue(newValue)
      }}
    />
  )
}

export default SearchTextField
